import { IPendoConfig } from '@assess/browser/pendo';

export const pendo: IPendoConfig = {
  enabled: window.APP_CONFIG.PENDO_ENABLED === 'true',
  pendoEnvironment: window.APP_CONFIG.ACCOUNT_ID,
  pendoId: window.APP_CONFIG.CUSTOMER_ID,
  appVersion: window.APP_CONFIG.APP_VERSION,
};
